import React, { useState } from "react";
import Cookies from 'js-cookie';
import { ArithmeglyphsStore } from '../../ArithmeglyphsStore';
import { Page1, Page2, Page3, Page4 } from '../InstructionsPages';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { DotNavigation } from '../Instructions';
import { PuzzleNames } from '../../../../../utils/types';
import { DOMAIN } from '../../../shared/utils';
import './MobileInstructions.less';

const MobileInstructions = () => {
  const isOpen = ArithmeglyphsStore.useState(s => s.instructionsAreOpen);
  const [page, setPage] = useState(0);

  const nextPage = () => {
    if (page < 3) setPage(page + 1);
  };

  const prevPage = () => {
    if (page > 0) setPage(page - 1);
  };

  return (
    <div className={`arithmeglyphsMobileInstructions ${isOpen ? 'popupOpen' : ''}`}>
      <div className="popupHeader">
        <button className="closeButton" onClick={() => {
          ArithmeglyphsStore.update(s => {
            s.instructionsAreOpen = false;
            s.isSoftPaused = false;
          });
          Cookies.set(`${PuzzleNames.Arithmeglyphs}InstructionsDismissed`, 'true', {
            domain: DOMAIN,
            expires: 365,
          });
          setTimeout(() => setPage(0), 100);
        }}>×</button>
        <h2 className="popupTitle">How to Play Arithmeglyphs</h2>
      </div>
      <div className="popupBody">
        <div className="pages" style={{ transform: `translateX(-${page * 25}%)` }}>
          <Page1/>
          <Page2/>
          <Page3/>
          <Page4/>
        </div>
        <div className="navigation">
          <button onClick={prevPage} disabled={page === 0}>
            <ArrowBackIosIcon/>
          </button>
          <DotNavigation numDots={4} page={page} onDotClick={(i: number) => {
            setPage(i);
          }}/>
          <button onClick={nextPage} disabled={page === 3}>
            <ArrowForwardIosIcon/>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileInstructions;